import status from '../Status';
import { DOCUMENT_LAST } from '../../Api/ApiUrls'

export const getDocumentLast = async ({ body }) => {
  try {
    const res = await fetch(DOCUMENT_LAST, {
      method: 'POST',
      body: JSON.stringify(body),
    });
    const checkd = status.checkStatus(res);
    const json = await checkd.json();
    return json;
  } catch (err) {
    console.log('Document Last Error', err);
    throw new Error(err.message);
  }
};
